<template>
    <Card class="report-head-card mt-3 h-[480px]">
        <div class="flex h-full w-full flex-col">
            <div class="mb-[52px] mt-5 h-8 shrink-0">
                <img src="@/assets/images/logo.png" alt="eureka">
            </div>
            <div class="w-150 grow text-3xl">{{props.title}}️</div>
            <div class="shrink-0 text-base text-grey-90">{{ $t('createReportDate') }}</div>
            <div class="shrink-0 text-base text-black">{{props.date}}</div>
        </div>
    </Card>
</template>
<script setup lang="ts">
import { withDefaults } from 'vue';
import Card from '../Card.vue'

const props = withDefaults(defineProps<{
    title: string
    date: string
}>(), {
    title: '',
    date: '',
})
</script>
<style>
.report-head-card {
    background: linear-gradient(to right, #FFFFFF 52%, rgba(0, 0, 0, 0)), url('@/assets/images/headBanner.png') no-repeat right;
    background-size: contain;
}
</style>
